import { TabView } from "@grindex-client/components/Tabs/TabView.class";
import { baseLink } from "@grindex-common/helpers/baseLink";

function init($views) {
	const ROUTES = {
		"/": "summary",
		"/video/": "video",
		"/products/": "products",
	};

	$views.forEach(($advancedCaseStudyTab) => {
		const tabView = new TabView(baseLink.getBaseLinkWithoutSegments(window.config.advancedCaseStudy.tabs), ROUTES, $advancedCaseStudyTab);

		tabView.init();
	});
}

export default {
	view: "advancedCaseStudyTab",
	init,
};
